import { Link } from "react-router-dom";
import { XCircle, Phone } from "lucide-react";

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-[#081C15] grain-overlay flex items-center justify-center px-5">
      <div className="max-w-md w-full rounded-2xl bg-white/5 border border-white/15 p-10 text-center text-white" data-testid="payment-cancel-page">
        <XCircle size={40} className="mx-auto text-[#D4AF37]" />
        <h1 className="mt-6 font-display font-bold text-2xl">Payment cancelled</h1>
        <p className="mt-3 text-sm text-[#D8E2DC] leading-relaxed">
          No charge was made. You can restart the payment anytime from your link, or reach
          out and we'll help you book directly.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/#contact"
            data-testid="payment-cancel-retry"
            className="inline-flex items-center gap-2 rounded-full bg-[#D4AF37] text-[#081C15] px-6 py-3 font-display font-bold text-sm hover:brightness-110 transition duration-200"
          >
            Back to site
          </Link>
          <a
            href="tel:+19709023321"
            data-testid="payment-cancel-call"
            className="inline-flex items-center gap-2 rounded-full border-2 border-white/25 text-white px-6 py-3 font-display font-bold text-sm hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-200"
          >
            <Phone size={15} />
            1-970-902-3321
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
